import {Constants} from "@unibuddy/intl";

/**
 * @param customTexts: custom texts for signup in multiple languages
 * @param selectedLocale
 * @returns {*|string}: custom text in selected locale
 */
export function getCustomTextInLocale(customTexts, selectedLocale) {
    const customTextInLocale = customTexts.find(
        (customText) => customText.locale === selectedLocale,
    );

    if (customTextInLocale) return customTextInLocale.text;

    const customTextInDefaultLocale = customTexts.find(
        (customText) => customText.locale === Constants.DEFAULT_LOCALE,
    );

    return customTextInDefaultLocale ? customTextInDefaultLocale.text : "";
}
